import React from 'react';
import { getInitials } from '../../utils/helpers';

export default function Avatar({ src, name = '', size = 'md', className = '' }) {
  const sizes = { xs: 'w-8 h-8 text-xs', sm: 'w-10 h-10 text-sm', md: 'w-14 h-14 text-base', lg: 'w-20 h-20 text-xl', xl: 'w-28 h-28 text-2xl' };
  const cls   = `${sizes[size]} rounded-full overflow-hidden flex-shrink-0 bg-primary-light flex items-center justify-center font-semibold text-primary ${className}`;

  if (src) {
    return <img src={src} alt={name} className={`${sizes[size]} rounded-full object-cover flex-shrink-0 ${className}`} />;
  }
  return <div className={cls}>{getInitials(name)}</div>;
}
